import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApplicationUser, AuthService, ResetPasswordRequest, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';

@Injectable({
    providedIn: 'root'
})
export class UsersService extends ServiceBase {

    constructor(private http: HttpClient,
        authService: AuthService) {
        super(authService);
    }

    public getUserDetails(): Observable<ApplicationUser> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/user';
        const method: string = '/details';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.get<ApplicationUser>(url, httpOptions);
    }


   public updateUserOnboardingStep(onboardingStepId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api = '/User';
    const method = '/update-user-onBoarding-step';
    const url = `${environment.BASE_API_PATH}${api}${method}?OnboardingStepId=${onboardingStepId}`;
    return this.http.post<ResponseObject>(url, null, httpOptions);
}



   public fetchUserOnboardingSteps(): Observable<any> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/user';
    const method: string = '/fetch-user-onboarding-steps';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.get<any>(url, httpOptions);
}


   public SkipOnboardingChecklist(): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const api: string = '/user';
    const method: string = '/SkipOnboardingChecklist';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
}


    public updateUser(userId: string, updateData: ApplicationUser): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/${userId}/update`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, updateData, httpOptions);
    }

    public updateArtistBankingInformation(updateData: ArtistBankingInformation): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/encrypt-banking-info`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, updateData, httpOptions);
    }

    public getArtistBankingInfo(password: string): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/artist-banking-info`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, { Password: password }, httpOptions);
    }

    public updateArtistAndGallerySetting(userId: string, updateData: ApplicationUser): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/${userId}/updateSettings`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, updateData, httpOptions);
    }

    public sendForgotPasswordMail(data: ForgotPasswordMailRequest): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = '/forgot-password';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, data, httpOptions);
    }

    public resetForgottenPassword(userId: string, updateData: ResetPasswordRequest): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/${userId}/reset-forgotten-password`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, updateData, httpOptions);
    }

    public startFreeTrail(): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/StartInitialTrial`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

    public endFreeTrail(): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/EndInitialTrial`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

    public updateSubscriptionRuleSetUser(userId: string, subscriptionRuleSetId: string): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/update-subscriptionRuleSetId/${subscriptionRuleSetId}-ofUser/${userId}`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

    public proAnyUserByPlateformUser(UserId: string, SetPro: boolean): Observable<ResponseObject> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/User';
        const method: string = `/UpdateProStatusByPlatform/${UserId}/${SetPro}`;
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

}

export class ForgotPasswordMailRequest {
    Email!: string;
}

export class ArtistBankingInformation {
    UniqueAccessCode?: string;
    BankName?: string;
    BankAddress?: string;
    BankBSB?: string;
    AccountNumber?: string;
}